import { groq } from 'next-sanity';
import { z } from 'zod';

import { image, SanityImage } from './image';

export const SanityLottieAnimation = z.object({
  _type: z.literal('lottieAnimation'),
  _key: z.string().optional().nullable(),
  url: z.string(),
  width: z.number(),
  height: z.number(),
  loop: z.boolean(),
  roundedCorners: z.boolean(),
  fallback: SanityImage,
});
export type SanityLottieAnimation = z.infer<typeof SanityLottieAnimation>;

export const lottieAnimation = groq`{
  _type,
  "loop": coalesce(loop, true),
  "roundedCorners": coalesce(roundedCorners, false),
  defined(_key) => {
    _key,
  },
  ...(lottieFile.asset-> {
    url,
  }),
  width,
  height,
  fallback ${image},
}`;
